import { useComponent, useElement, useLocale } from "../../../hooks";
import { useNotifications } from "./hooks";

export const AdminNotifications = () => {
  const { t } = useLocale();
  const Button = useElement("Button");
  const Link = useElement("Link");
  const Input = useElement("Input");
  const Table = useComponent("Table");
  const TrashConfirmModal = useComponent("TrashConfirmModal");
  const {
    trackScrolling,
    checkedList,
    checkedAll,
    setisMultipleDelete,
    setshowTrashConfirm,
    searchKey,
    search,
    resetSearch,
    tableContent,
    activeShownTotal,
    deleteChecked,
    deleteSelectNotification,
    trashCancel,
    showTrashConfirm,
    isMultipleDelete,
  } = useNotifications();

  return (
    <div id="content-box" className="content" onScroll={trackScrolling}>
      <h1 className="title flex">
        All Notifications
        <Link
          className="btn btn-primary btn-small ml20"
          href="/admin/notification/add"
        >
          {t("add")}
        </Link>
        {(checkedList.length !== 0 || checkedAll) && (
          <Button
            onClick={() => {
              setisMultipleDelete(true);
              setshowTrashConfirm(true);
            }}
            className="btn btn-outline btn-small"
          >
            {t("delete")}
          </Button>
        )}
      </h1>
      <div className="filter-box">
        <div className="filters"></div>
        <div className="search-box">
          <Input
            name="searchKey"
            value={searchKey || ""}
            placeholder={t("placeholder.search")}
            onChange={search}
          />
          <i className="hi-close" onClick={resetSearch}></i>
        </div>
      </div>
      <Table data={tableContent} pageSize={activeShownTotal} />
      <TrashConfirmModal
        trashOkAction={() => {
          isMultipleDelete ? deleteChecked() : deleteSelectNotification();
        }}
        trashCancelAction={trashCancel}
        showTrashConfirm={showTrashConfirm}
        isMultipleDelete={isMultipleDelete}
      />
    </div>
  );
};
